import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import BasicForm from './basic-form/basic-form.vue';
import LandForm from './land-form/land-form.vue'; // 耕地
import WoodsForm from './woods-form/woods-form.vue'; // 林地
import WaterForm from './water-form/water-form.vue'; // 水面
import SihuangForm from './sihuang-form/sihuang-form.vue'; // 四荒
import HouseForm from './house-form/house-form.vue';
import FacilityForm from './facility-form/facility-form.vue'; // 设备设施
import OtherForm from './other-form/other-form.vue';
import synthesizeForm from './synthesize-form/synthesize-form.vue'; // 综合类

import PublishProjectService from '../publish-project-service.js';
import { errorMessage } from '@/utils/message.js';
const debounce = require('lodash.debounce');
import { mapGetters } from 'vuex';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    ProcessNavigation,
    BasicForm,
    LandForm,
    WoodsForm,
    OtherForm,
    WaterForm,
    SihuangForm,
    FacilityForm,
    HouseForm,
    synthesizeForm
  },
  data() {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑受让资格', '上传附件信息', '重大事项提示', '承诺信息', '提交申请'],
      step: 2,
      id: '',
      oldId: '',
      isCreated: true,
      projectInfo: {},
      landTotalForm: {},
      submitStatus: 'init',
      projectType: '1',
      projectSubType: '1',
      test: null,
      assetsCode: '',
      // 对接农经一键发包
      assetsId: null,
      assetsmassifs: [],
      callBackUrl: ''
    };
  },
  computed: {
    ...mapGetters([
      'processList',
      'tradeType',
      'userInfo'
    ])
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    this.assetsCode = this.$route.query.assetsCode;
    this.callBackUrl = this.$route.query.callBackUrl;
    if (this.$route.query.tradeType) {
      this.$store.commit('SET_TRADE_TYPE', this.$route.query.tradeType);
    }
    if(Number(this.tradeType) === 2) {
      this.step = 1;
    }
    // 查询农经系统要一键发包的信息
    this.getassetsList();
    this.resultGet();
    this.assetsCode && this.selectInfoByProjectId();
  },
  mounted() {
  },
  methods: {
    // 获取资产系统带过来的类型和资产
    getassetsList () {
      if (this.$route.query.assetsId && this.$route.query.accessToken) {
        this.assetsId = this.$route.query.assetsId;
        PublishProjectService.getAssetsInfo({assetsId: this.assetsId, callBackUrl: this.callBackUrl}).then(res => {
          if (res.code === '0') {
            this.assetsmassifs = res.data;
          }
        }).catch(error => {
          errorMessage(error && error.data.reason);
        });
      }
    },
    // clear from
    fromClear() {
      this.$nextTick(() => {
        Object.keys(this.$refs).forEach(item => {
          if(this.$refs[item] && this.$refs[item].clear) {
            this.$refs[item].clear && this.$refs[item].clear();
          }
        });
      });
    },
    // 获取资产信息
    selectInfoByProjectId() {
      PublishProjectService.selectInfoByProjectId(this.assetsCode).then(res => {
        if(res.code === '0' && res.data) {
          this.projectInfo = res.data;
        }
      }).catch(error => {
        console.log(error, '===error');
      });
    },
    resultGet() {
      if (this.id || this.oldId) {
        PublishProjectService.getProjectInfo({
          projectId: this.id || this.oldId,
          echoCode: 'PROJECT'
        }).then(res => {
          if (!res.data) {
            return;
          }
          this.projectInfo = res.data;
          if(res.data.projectType) {
            this.projectType = res.data.projectType;
          };
          if(res.data.projectSubType) {
            this.projectSubType = res.data.projectSubType;
          };
          if (this.oldId && !this.id) {
            this.isCreated = true;
          } else {
            this.isCreated = false;
          }
        });
      }
    },
    modulesChoose(e) {
      this.projectType = e[0];
      this.projectSubType = e[1];
    },
    // 上一步
    previousStep () {
      // let str = '';
      // if (this.id && this.oldId) {
      //   str = '?id=' + this.id + '&oldId=' + this.oldId;
      // } else if (this.id) {
      //   str = '?id=' + this.id;
      // } else if (this.oldId) {
      //   str = '?oldId=' + this.oldId;
      // }
      // this.$router.replace('/publish-project/publisher-info' + str);

      this.$router.replace({
        path: '/publish-project/publisher-info',
        query: this.$route.query
      });
    },
    onLandTotalForm (event) {
      this.landTotalForm = event;
    },
    // 下一步
    next: debounce(function(){
      if (this.submitStatus === 'ongoing') {return;}
      // if(this.$refs['landForm'] && this.$refs['landForm'].test()) {
      //   this.test = this.$refs['landForm'].test();
      // } else if(this.$refs['woodsForm'] && this.$refs['woodsForm'].test()) {
      //   this.test = this.$refs['woodsForm'].test();
      // } else if(this.$refs['waterForm'] && this.$refs['waterForm'].test()) {
      //   this.test = this.$refs['waterForm'].test();
      // } else if(this.$refs['sihuangForm'] && this.$refs['sihuangForm'].test()) {
      //   this.test = this.$refs['sihuangForm'].test();
      // } else if(this.$refs['houseForm'] && this.$refs['houseForm'].test()) {
      //   this.test = this.$refs['houseForm'].test();
      // }  else if(this.$refs['facilityForm'] && this.$refs['facilityForm'].test()) {
      //   this.test = this.$refs['facilityForm'].test();
      // }  else if(this.$refs['synthesizeForm'] && this.$refs['synthesizeForm'].test()) {
      //   this.test = this.$refs['synthesizeForm'].test();
      // }
      let formList = [
          this.$refs['basicForm'].test(),
          this.$refs['landForm']?.test(),
          this.$refs['woodsForm']?.test(),
          this.$refs['waterForm']?.test(),
          this.$refs['sihuangForm']?.test(),
          this.$refs['houseForm']?.test(),
          this.$refs['facilityForm']?.test(),
          this.$refs['synthesizeForm']?.test(),
          this.$refs['otherForm'].test()
      ];
      Promise.all(formList).then(res => {
        const obj = {
          ...res[0],
          ...res[1],
          ...res[2],
          ...res[3],
          ...res[4],
          ...res[5],
          ...res[6],
          ...res[7],
          ...res[8]
        };
        if (obj.payType !== '2') {
          delete obj.installments;
        } else {
          obj.installments.forEach(item => delete item.key);
        }
        if(this.callBackUrl) {
          obj['callBackUrl'] = this.callBackUrl;
        }
        obj.assetsInfo = JSON.stringify(obj.massifs);
        delete obj.massifs;
        if(this.assetsCode) {
          obj['assetsCode'] = this.assetsCode;
          // 资产跳转过来，项目每次都是新增
          this.oldId = this.id;
          this.isCreated = true;
        }
        obj.status = this.projectInfo.status;
        console.log(obj);
        this.submitStatus = 'ongoing';
        if (this.isCreated) {
          this.saveProjectInfo(obj);
        } else {
          this.updateProjectInfo(obj);
        }
      }, (error) => {
        console.log(error);
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 保存
    saveProjectInfo (obj) {

      // 重新申请带上oldId
      if (this.oldId) {
        obj.oldId = this.oldId;
      }
      PublishProjectService.saveProjectInfo(obj).then(res => {
        if (res && res.code === '0') {
          this.submitStatus = 'success';
          this.id = res.data;
          if (this.$refs['basicForm'].ruleForm.tradeType === '1') {
            if (this.oldId) {
              this.$router.push('/publish-project/transferee-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + obj.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType);
            } else {
              this.$router.push('/publish-project/transferee-info?id=' + this.id + '&tradeType=' + obj.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType );
            }
          } else {
            if (this.oldId) {
              this.$router.push('/publish-project/attachment-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + obj.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType );
            } else {
              this.$router.push('/publish-project/attachment-info?id=' + this.id + '&tradeType=' + obj.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType);
            }
          }
        } else if (res && res.reason) {
          this.submitStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.submitStatus = 'failed';
          errorMessage('保存项目信息失败');
        }
      }, (error) => {
        this.submitStatus = 'failed';
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存项目信息失败');
        }
      });
    },
    // 更新
    updateProjectInfo (obj) {
      PublishProjectService.updateProjectInfo({
        ...obj,
        projectId: this.id
      }).then(res => {
        console.log(obj);
        if (res && res.code === '0') {
          this.submitStatus = 'success';
          if (this.$refs['basicForm'].ruleForm.tradeType === '1') {
            if (this.oldId) {
              this.$router.push('/publish-project/transferee-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType  + '&projectSubType=' + obj.projectSubType);
            } else {
              this.$router.push('/publish-project/transferee-info?id=' + this.id + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType  + '&projectSubType=' + obj.projectSubType);
            }
          } else {
            if (this.oldId) {
              this.$router.push('/publish-project/attachment-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType  + '&projectSubType=' + obj.projectSubType );
            } else {
              this.$router.push('/publish-project/attachment-info?id=' + this.id + '&tradeType=' + obj.tradeType + '&projectType=' + obj.projectType  + '&projectSubType=' + obj.projectSubType);
            }
          }
        } else if (res && res.reason) {
          this.submitStatus = 'failed';
          errorMessage(res && res.reason);
        } else {
          this.submitStatus = 'failed';
          errorMessage('保存项目信息失败');
        }
      }, (error) => {
        this.submitStatus = 'failed';
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存项目信息失败');
        }
      });
    }
  }
};
